import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { CompanyUserBuilder } from '../builders/company-user-builder';
import { CompanyUserListBuilder } from '../builders/company-user-list-builder';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
export class CompanyUsersApiService {
    constructor(api) {
        this.api = api;
    }
    listCompanyUsers(company) {
        return this.api.get(`/business/users/${company.id}`).toPromise().then(response => {
            return CompanyUserListBuilder.buildCompanyUserList(response);
        });
    }
    createCompanyUser(user, company) {
        let payload = CompanyUserBuilder.buildCompanyUserPayload(user, true);
        return this.api.post(`/business/user/${company.id}`, JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    createCompanyUsers(company, users) {
        let payload = users.map(user => {
            return CompanyUserBuilder.buildCompanyUserPayload(user, true);
        });
        return this.api.post(`/business/users/${company.id}`, JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    updateCompanyUser(company, user) {
        let payload = CompanyUserBuilder.buildCompanyUserPayload(user, false);
        return this.api.put(`/business/users/${company.id}`, JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    deleteCompanyUser(company, user) {
        return this.api.delete(`/business/user/${company.id}/${user.userId}`)
            .toPromise().then(response => response);
    }
    deleteCompanyUserInvitation(user) {
        return this.api.delete(`/business/user_invitation/${user.invitationId}`)
            .toPromise().then(response => response);
    }
}
CompanyUsersApiService.ɵfac = function CompanyUsersApiService_Factory(t) { return new (t || CompanyUsersApiService)(i0.ɵɵinject(i1.AuthenticatedApiService)); };
CompanyUsersApiService.ɵprov = i0.ɵɵdefineInjectable({ token: CompanyUsersApiService, factory: CompanyUsersApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(CompanyUsersApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }]; }, null); })();
//# sourceMappingURL=company-users-api.service.js.map